import { ContactFormThemeSection } from './ContactFormThemeSection';
import { InquiryForm } from './InquiryForm';

export const ContactForm = () => {
    return (
        <div className="flex w-full">
            <ContactFormThemeSection />

            <div className="w-1/3 bg-[#DADADA]/20 min-h-screen p-8">
                <InquiryForm />
            </div>
        </div>
    );
};
